import { composeClassNames } from "@faedev/editor-utils";
import NextImage from "next/image";
import { CSSProperties } from "react";
import { Jumbotron } from "react-bootstrap";
import Content from "src/components/Content";
import MqGteTablet from "src/components/MqGteTablet";
import MqPhone from "src/components/MqPhone";
import constants from "src/constants";
import styleImageWrapper from "src/functions/styleImageWrapper";
import { sInstructorImg } from "src/styles/sInstructorImg.module.scss";
import { sProfileHead } from "src/styles/sProfileHead.module.scss";
import { sProfileMotive } from "src/styles/sProfileMotive.module.scss";
import { ApiMotive } from "src/types/ApiMotive";
import { ApiThumbnail } from "src/types/ApiThumbnail";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  motiveImg: ApiMotive;
  profileImg: ApiThumbnail;
};

function ProfileHead({ style, className, motiveImg, profileImg }: Props) {
  const MotiveDesktop = (
    <NextImage
      className={`profile-motive-photo`}
      src={constants.Paths.imagesUrl + motiveImg?.image?.url}
      alt={motiveImg?.image?.alternativeText}
      layout="fill"
      objectFit={
        motiveImg?.width !== "fill" || motiveImg?.height !== "fill"
          ? "contain"
          : motiveImg?.object_fit
      }
      /* TODO: check if object fit + layout cover all possible settings
          style={styleImage(
            motiveImg.width,
            motiveImg.height,
            motiveImg.object_fit
          )}
          */
    />
  );
  return (
    <Jumbotron
      className={composeClassNames([sProfileHead, className, "profile-images"])}
      style={style}
    >
      {motiveImg ? (
        motiveImg.image ? (
          <div
            className={composeClassNames([sProfileMotive, "profile-motive"])}
            style={styleImageWrapper(
              motiveImg.align,
              motiveImg.background_color,
              motiveImg.background_pattern
            )}
          >
            <MqGteTablet>{MotiveDesktop}</MqGteTablet>
            <MqPhone>
              {!motiveImg.apply_mobile ? (
                <NextImage
                  className={`profile-motive-photo`}
                  src={constants.Paths.imagesUrl + motiveImg.image.url}
                  alt={motiveImg.image?.alternativeText}
                  layout="fill"
                  objectFit="cover"
                />
              ) : (
                MotiveDesktop
              )}
            </MqPhone>
          </div>
        ) : null
      ) : null}
      {profileImg ? (
        <>
          <MqGteTablet>
            <Content fluid={`xl`}>
              <div
                className={composeClassNames([
                  sInstructorImg,
                  "bordered",
                  "shadow",
                  "profile-photo",
                ])}
              >
                <NextImage
                  className={composeClassNames([sInstructorImg, "rounded"])}
                  alt={profileImg.alternativeText}
                  src={constants.Paths.imagesUrl + profileImg.url}
                  width={constants.Images.profilePhotoDesktop}
                  height={constants.Images.profilePhotoDesktop}
                  objectFit="cover"
                />
              </div>
            </Content>
          </MqGteTablet>
          <MqPhone>
            <div
              className={composeClassNames([
                sInstructorImg,
                "bordered",
                "shadow",
                "profile-photo",
              ])}
            >
              <NextImage
                className={composeClassNames([sInstructorImg, "rounded"])}
                alt={profileImg.alternativeText}
                src={constants.Paths.imagesUrl + profileImg?.url}
                width={constants.Images.profilePhotoPhone}
                height={constants.Images.profilePhotoPhone}
                objectFit="cover"
              />
            </div>
          </MqPhone>
        </>
      ) : null}
    </Jumbotron>
  );
}

export default ProfileHead;
